import ScoreBoard from "./ScoreBoard";

export default ScoreBoard;